import { useField } from 'formik';

import { Checkbox, CheckboxProps } from '../Checkbox/Checkbox';

interface CheckboxFieldProps extends CheckboxProps {
  name: string;
}

export function CheckboxField({ name, checkboxProps, ...rest }: CheckboxFieldProps) {
  const [field] = useField(name);

  return (
    <Checkbox
      {...rest}
      checkboxProps={{
        ...checkboxProps,
        ...field,
        onChange: (event) => {
          checkboxProps?.onChange?.(event);
          field.onChange(event);
        },
        checked: field.value,
      }}
    />
  );
}
